/* ============================================================================
   Lagoon "Add & Save" pillowcase add-on  ·  assets/lagoon-addon.js
   ----------------------------------------------------------------------------
   "Right way" wiring for the Booster theme (and any theme):

   We do NOT intercept the Add-to-cart button. Booster adds the pillow with its
   own handler exactly as normal. We watch the /cart/add network call and, when
   the pillow is added with the add-on checked, we slip the matched pillowcase
   into the cart alongside it — then let Booster/Rebuy open + refresh the cart.
   This cooperates with the theme instead of fighting it, so it's robust.

   Also: size-syncs the case, mirrors WELCOME20 as a strikethrough, and on
   "-recommend" handles auto-applies WELCOME20 so cart/checkout = the PDP price.

   Config via window.LAGOON_ADDON_CONFIG (set BEFORE this script).
   ========================================================================== */
(function () {
  "use strict";

  var CFG = Object.assign({
    welcomeCode: "WELCOME20",
    recommendSuffix: "-recommend",
    autoApplyOnRecommend: true,
    showStrikethrough: true,            // set false during sitewide sales
    caseAlwaysDiscounted: true,         // PCSAVE20 (Buy a pillow, get $20 off a pillowcase) is live → always show the case strikethrough
    sizeOptionName: "Size",
    productFormSelector: 'form[action$="/cart/add"]',
    atcButtonSelector: '[name="add"], .product__atc, [data-atc]', // label only (optional)
    pillowPriceSelector: "[data-lg-pillow-price]",
  }, window.LAGOON_ADDON_CONFIG || {});

  var money = function (c) { return "$" + (c / 100).toFixed(2); };
  var instances = [];          // every add-on block on the page
  var LG_ADDING = false;       // guard so our own case-add isn't re-detected
  var lastAppend = 0;          // debounce companion adds

  /* ---- auto-apply WELCOME20 on recommend pages --------------------------- */
  function isRecommend(root) {
    var h = (root && root.getAttribute("data-pillow-handle")) || "";
    return h.indexOf(CFG.recommendSuffix) !== -1 || location.pathname.indexOf(CFG.recommendSuffix) !== -1;
  }
  function autoApplyWelcome() {
    try {
      if (sessionStorage.getItem("lg_welcome_applied") === "1") return;
      fetch("/discount/" + encodeURIComponent(CFG.welcomeCode), { credentials: "same-origin" })
        .then(function () { sessionStorage.setItem("lg_welcome_applied", "1"); }).catch(function () {});
    } catch (e) {}
  }

  /* ---- watch the theme's /cart/add and append the case ------------------- */
  var RE_ADD = /\/cart\/add(\.js)?(\?|$)/;
  function hookCartAdds() {
    // fetch()
    var of = window.fetch;
    if (of && !of.__lgWrapped) {
      window.fetch = function (input, init) {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        var method = (init && init.method) || (input && input.method) || "GET";
        var isAdd = RE_ADD.test(url) && String(method).toUpperCase() === "POST";
        var p = of.apply(this, arguments);
        if (isAdd && !LG_ADDING) p.then(function (r) { if (r && r.ok) onThemeAdd(); }).catch(function () {});
        return p;
      };
      window.fetch.__lgWrapped = true;
    }
    // XMLHttpRequest
    var oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
    if (!oSend.__lgWrapped) {
      XMLHttpRequest.prototype.open = function (m, u) {
        this.__lgAdd = RE_ADD.test(u || "") && String(m || "").toUpperCase() === "POST";
        return oOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        if (this.__lgAdd && !LG_ADDING) this.addEventListener("load", function () {
          if (this.status >= 200 && this.status < 300) onThemeAdd();
        });
        return oSend.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send.__lgWrapped = true;
    }
  }

  function onThemeAdd() {
    var now = Date.now();
    // Stand down if OUR custom cart initiated this add/change — otherwise we'd
    // re-add the companion case on top of a Peak Set swap or an accessory add.
    if (now - (window.__lgcOp || 0) < 2500) return;
    if (now - lastAppend < 1200) return;     // debounce
    var items = [];
    instances.forEach(function (it) {
      var cv = it.companion();
      if (cv) items.push({ id: cv.id, quantity: 1 });
    });
    if (!items.length) return;
    lastAppend = now;
    LG_ADDING = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items }),
    })
      .then(function () { LG_ADDING = false; refreshCart(); })
      .catch(function () { LG_ADDING = false; });
  }

  /* ---- open / refresh the cart (Rebuy + Booster) ------------------------- */
  function refreshCart() {
    try { if (window.Rebuy && Rebuy.SmartCart && Rebuy.SmartCart.reload) { Rebuy.SmartCart.reload(); if (Rebuy.SmartCart.show) Rebuy.SmartCart.show(); return; } } catch (e) {}
    document.dispatchEvent(new CustomEvent("rebuy:cart.change", { bubbles: true }));
    try { if (window.BoosterTheme && BoosterTheme.events) BoosterTheme.events.trigger("booster:content:update"); } catch (e) {}
  }

  /* ---- per-block init ---------------------------------------------------- */
  function initAddon(root) {
    var card = root.querySelector("[data-lg-card]");
    if (!card) return;
    var hasColor = root.getAttribute("data-has-color") === "true";
    var offerOff = parseInt(root.getAttribute("data-offer-off") || "0", 10);
    var strike = CFG.showStrikethrough && isRecommend(root);          // pillow: WELCOME20 on -recommend only
    var caseStrike = CFG.showStrikethrough && (CFG.caseAlwaysDiscounted || isRecommend(root)); // case: PCSAVE20 applies whenever bought with a pillow
    var pillowHandle = root.getAttribute("data-pillow-handle");

    var variants = [];
    try { variants = JSON.parse(root.querySelector("[data-lg-case-variants]").textContent); } catch (e) {}

    var st = {
      checked: card.querySelector("[data-lg-toggle]").classList.contains("is-on"),
      size: "Queen",
      color: hasColor ? (variants.find(function (v) { return v.color; }) || {}).color : null,
      pillowPrice: 0, sizeMap: {},
    };
    function caseVariant() {
      return variants.find(function (v) { return v.size === st.size && (!hasColor || v.color === st.color); }) || variants[0];
    }

    function render() {
      var cv = caseVariant();
      var base = cv ? cv.price : 0;
      var now = Math.max(0, base - (caseStrike ? offerOff : 0));
      root.querySelector("[data-lg-add]").textContent = "+ " + money(caseStrike ? now : base);
      var w = root.querySelector("[data-lg-was]"), s = root.querySelector("[data-lg-save]");
      if (caseStrike && offerOff > 0) { w.textContent = money(base); w.hidden = false; s.textContent = "SAVE " + money(base - now); s.hidden = false; }
      else { w.hidden = true; s.hidden = true; }
      var em = root.querySelector("[data-lg-size]"); if (em) em.textContent = st.size;
      card.classList.toggle("is-sel", st.checked);
      var cfg = root.querySelector("[data-lg-config]"); if (cfg) cfg.classList.toggle("is-hidden", !st.checked);
      // pillow price mirror (resilient — see paintPillow)
      paintPillow();
      // ATC label (best-effort; safe if not found)
      var btn = document.querySelector(CFG.atcButtonSelector);
      if (btn && st.pillowPrice) {
        var lbl = btn.querySelector("[data-lg-atc-label]");
        if (lbl) {
          var pd = strike ? Math.max(0, st.pillowPrice - offerOff) : st.pillowPrice;
          var cd = caseStrike ? now : base;
          lbl.textContent = (st.checked ? "Add bundle to cart" : "Add to cart") + " · " + money(pd + (st.checked ? cd : 0));
        }
      }
    }

    function syncFromForm() {
      var form = document.querySelector(CFG.productFormSelector);
      var idInput = form && form.querySelector('[name="id"]');
      if (!idInput) return;
      var id = parseInt(idInput.value, 10);
      if (id && st.sizeMap[id]) { st.size = st.sizeMap[id].size; st.pillowPrice = st.sizeMap[id].price; render(); }
    }

    /* ---- resilient pillow strikethrough ----
       The recommend template renders MULTIPLE price blocks (main + sticky +
       quick-view). We paint EVERY [data-product-price]: insert our own span
       after it (creating one if the Liquid edit isn't in that block), fill it
       with now+was, and hide Booster's original. Booster re-renders the price
       on load/variant-change, so we re-assert via timeouts + a MutationObserver
       on each price holder. Idempotent, with a guard against observer loops. */
    var lgPainting = false, priceObservers = [];
    function paintPillow() {
      if (!strike || !st.pillowPrice) return;
      var origs = document.querySelectorAll("[data-product-price]");
      if (!origs.length) return;
      var html = '<span class="lg-now">' + money(Math.max(0, st.pillowPrice - offerOff)) + '</span> <span class="lg-was">' + money(st.pillowPrice) + "</span>";
      // needs work?
      var dirty = false;
      [].forEach.call(origs, function (orig) {
        var holder = orig.parentNode; if (!holder) return;
        var span = holder.querySelector("[data-lg-pillow-price]");
        if (!span || span.innerHTML !== html || span.hidden || orig.style.display !== "none") dirty = true;
      });
      if (!dirty) return;
      lgPainting = true;
      priceObservers.forEach(function (o) { o.disconnect(); });
      [].forEach.call(origs, function (orig) {
        var holder = orig.parentNode; if (!holder) return;
        var span = holder.querySelector("[data-lg-pillow-price]");
        if (!span) {
          span = document.createElement("span");
          span.setAttribute("data-lg-pillow-price", "");
          span.className = "product__price";
          orig.insertAdjacentElement("afterend", span);
        }
        if (span.innerHTML !== html) span.innerHTML = html;
        span.hidden = false;
        if (orig.style.display !== "none") orig.style.display = "none";
      });
      priceObservers.forEach(function (o, i) { var h = origObservedHolders[i]; if (h) o.observe(h, { childList: true, subtree: true, attributes: true }); });
      lgPainting = false;
    }
    var origObservedHolders = [];
    function watchPrice() {
      if (!strike) return;
      var origs = document.querySelectorAll("[data-product-price]");
      [].forEach.call(origs, function (orig) {
        var holder = orig.parentNode; if (!holder || origObservedHolders.indexOf(holder) !== -1) return;
        origObservedHolders.push(holder);
        var ob = new MutationObserver(function () { if (!lgPainting) paintPillow(); });
        ob.observe(holder, { childList: true, subtree: true, attributes: true });
        priceObservers.push(ob);
      });
      [200, 600, 1200, 2500].forEach(function (t) { setTimeout(paintPillow, t); });
    }

    fetch("/products/" + pillowHandle + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var si = p.options.findIndex(function (o) { return (o.name || o) === CFG.sizeOptionName; });
        p.variants.forEach(function (v) { st.sizeMap[v.id] = { size: si >= 0 ? v.options[si] : v.option1, price: v.price }; });
        syncFromForm();
      }).catch(render);

    // interactions
    root.querySelector("[data-lg-toggle]").addEventListener("click", function () {
      st.checked = !st.checked; this.classList.toggle("is-on", st.checked);
      this.setAttribute("aria-pressed", String(st.checked)); render();
    });
    root.querySelectorAll("[data-lg-color]").forEach(function (sw) {
      sw.addEventListener("click", function () {
        st.color = sw.getAttribute("data-lg-color");
        root.querySelectorAll("[data-lg-color]").forEach(function (s) { s.classList.toggle("is-on", s === sw); });
        render();
      });
    });
    var form = document.querySelector(CFG.productFormSelector);
    if (form) {
      form.addEventListener("change", syncFromForm);
      document.addEventListener("variant:change", syncFromForm);
      var idInput = form.querySelector('[name="id"]');
      if (idInput) new MutationObserver(syncFromForm).observe(idInput, { attributes: true, attributeFilter: ["value"] });
    }

    render();
    watchPrice();
    // expose the companion item for the global add-hook
    instances.push({ companion: function () { var cv = caseVariant(); return (st.checked && cv && cv.available) ? cv : null; } });
  }

  /* ---- boot -------------------------------------------------------------- */
  function boot() {
    var roots = document.querySelectorAll("[data-lg-addon]");
    if (!roots.length) return;
    try { console.log("[lagoon-addon] v3 loaded — multi-block pillow strikethrough"); } catch (e) {}
    if (CFG.autoApplyOnRecommend && [].some.call(roots, isRecommend)) autoApplyWelcome();
    hookCartAdds();
    roots.forEach(initAddon);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
